import { useState, useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'antd';
import logo from '../../assets/img/logo.png';

interface User {
  first_name: string;
}

// AP-5862: the package-upgrade bumped @ant-design/icons to a version that
// redesigned ExportOutlined's glyph (bracket frame + diagonal arrow) — the
// icon Production still ships is the pre-redesign glyph (box + horizontal
// arrow through a slot). That old glyph isn't available under any icon name
// in the installed package anymore, so it's reproduced here directly from
// production's own bundled SVG path rather than swapped for an unrelated icon.
const LegacyExportOutlined = (props: { onClick?: () => void }) => (
  <svg
    viewBox="64 64 896 896"
    width="1em"
    height="1em"
    fill="currentColor"
    onClick={props.onClick}
    style={{ cursor: 'pointer' }}
  >
    <path d="M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 000-12.6z" />
  </svg>
);

const HeaderView = () => {
  const [user, setUser] = useState<User>({ first_name: '' });
  const navigate = useNavigate();  // ✅ replaces withRouter + props.history

  useEffect(() => {
    const userString = localStorage.getItem('user') ?? '{}';
    const userObj: User = JSON.parse(userString);
    setUser(userObj);
  }, []);

  const onLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('order_type');
    navigate('/login');  // ✅ replaces props.history.push
  };

  return (
    <div className="header">
      <div className="header__left">
        <div className="header__logo">
          <div className="logo_img">
            <img src={logo} alt="appetit logo" />
          </div>
        </div>
      </div>
      <div className="header__right">
        <div className="profile-container">
          <div><UserOutlined /></div>
          <div className="profile-details">
            <label>{user.first_name}</label>
            <span>Administrator</span>
          </div>
        </div>
        <div className="action-icon primary">
          <Tooltip placement="bottomRight" title="Logout">
            <LegacyExportOutlined onClick={onLogout} />
          </Tooltip>
        </div>
      </div>
    </div>
  );
};

export default HeaderView;